import KPICard from "@/components/dashboard/KPICard";

export default function KPIGrid({ items = [], isLoading = false }) {
  return (
    <div
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
      data-testid="kpi-grid"
    >
      {(isLoading ? Array.from({ length: 4 }) : items).map((item, index) => (
        <KPICard
          key={item?.key || index}
          title={item?.title}
          value={item?.value}
          changePercent={item?.changePercent}
          metaLabel={item?.metaLabel}
          metaValue={item?.metaValue}
          sparklineData={item?.sparklineData}
          valueFormatter={item?.valueFormatter}
          comparisonValue={item?.comparisonValue}
          comparisonLabel={item?.comparisonLabel}
          comparisonRangeLabel={item?.comparisonRangeLabel}
          comparisonValueFormatter={item?.comparisonValueFormatter}
          changeLabel={item?.changeLabel}
          invertTrend={item?.invertTrend}
          isLoading={isLoading}
          testId={item?.testId || `kpi-card-${index}`}
        />
      ))}
    </div>
  );
}